import { call, put, takeLatest } from "redux-saga/effects";
import { getMyAssignedTasks as getMyAssignedTasksAPI, updateTaskStatus as updateTaskStatusAPI } from "../http/requests/task";
import { TaskType, setMyAssignedTasks, setTaskLoading } from "../redux/actions/task";

function* getMyAssignedTasksSaga() {
  try {
    yield put(setTaskLoading(true));
    const tasks = yield call(getMyAssignedTasksAPI);
    console.log("Task Saga - API Response:", tasks);
    
    // Use API data only
    const taskData = tasks || [];
    yield put(setMyAssignedTasks(taskData));
  } catch (error) {
    console.error("Error fetching assigned tasks:", error);
    // Set empty array when API fails
    yield put(setMyAssignedTasks([]));
  } finally {
    yield put(setTaskLoading(false));
  }
}

function* updateTaskStatusSaga({ payload }) {
  try {
    const { taskId, statusData } = payload;
    yield call(updateTaskStatusAPI, taskId, statusData);
    // If API call succeeds, refresh the task list
    yield call(getMyAssignedTasksSaga);
  } catch (error) {
    console.error("Error updating task status:", error);
    throw error; // Re-throw to let the component handle it
  }
}

export function* taskSaga() {
  yield takeLatest(TaskType.GET_MY_ASSIGNED_TASKS, getMyAssignedTasksSaga);
  yield takeLatest(TaskType.UPDATE_TASK_STATUS, updateTaskStatusSaga);
}
